import { Component, Input } from '@angular/core';
import {
    AuthorisationRuleOutcome,
    RuleOutcome
} from '@flyfreely-portal-ui/flyfreely';
import { Angulartics2 } from 'angulartics2';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

enum Mode {
    BLOCK = 'BLOCK',
    ADVISE = 'ADVISE',
    PASS = 'PASS'
}

@Component({
    selector: 'authorisation-outcome-details-dialogue',
    templateUrl: './authorisation-outcome-details-dialogue.component.html',
    styleUrls: ['./styles.scss']
})
export class AuthorisationOutcomeDetailsDialogue {
    @Input() ruleOutcome: AuthorisationRuleOutcome;

    modalTitle: string;
    mode: Mode = Mode.ADVISE;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private angulartics2: Angulartics2,
        private modal: BsModalRef
    ) {}

    ngOnInit() {
        this.modalTitle = this.findModalTitle();
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    findModalTitle() {
        if (this.ruleOutcome == null) {
            return 'Unknown Authorisation Outcome';
        }
        switch (this.ruleOutcome.outcome) {
            case RuleOutcome.Outcome.BLOCK:
                this.mode = Mode.BLOCK;
                return this.ruleOutcome.title;
            case RuleOutcome.Outcome.ADVISE:
                this.mode = Mode.ADVISE;
                return this.ruleOutcome.title;
            case RuleOutcome.Outcome.PASS:
                this.mode = Mode.PASS;
                return this.ruleOutcome.title;
            default:
                return this.ruleOutcome.title;
        }
    }

    close() {
        this.modal.hide();
    }
}
